<template>
  <v-dialog persistent :value="addAppToBusiness" :width="'850'">
    <v-card>
      <popup-heading 
      title="SELECT BUSINESSES" 
      subtitle="Select the Businesses that will have access to this App">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
          <v-btn
            depressed
            @click="addAppToBusinessSubmit()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
          >
            <v-icon dark class="primary--text">check</v-icon>
          </v-btn>
        </template>
      </popup-heading>
      <v-card-text class="pop-header-fixed-content popup-height">
        <v-flex sm12 md12 class="nopadding-checkbox"> 
      
          <v-layout row wrap>
            <v-flex sm3 md4 lg4>
              <v-checkbox class="ml-3 pl-3 bulk-checkbox mt-6" color="primary" @click="bulkSelectToggle()" :label="bulk.label" v-model="bulk.value"></v-checkbox>
            </v-flex>
            <v-flex sm9 md8 lg8 class="text-right">
              <v-text-field
                class="search-input mr-3"
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout> 
        </v-flex>

        <div class="text-center mt-4 mb-4">
          <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
        </div>
        <v-data-table 
          :hide-default-header='true'
          :items="allBusinesses"
          class="pb-4 tabulardata"
          :search="search"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td class="text-left mr-0 pr-0" width="250">
                  <v-checkbox class="tbl-chekbox mr-0 pr-0" color="primary" :value="item.id" :label="item.name" v-model="form.businesses"></v-checkbox>
                </td>
              </tr>
            </tbody>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            No results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { some, isEmpty } from 'lodash';

export default {

  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      urlValidation: [
        v => !!v || 'Field is required',
        v =>
          /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/.test(v) || 'Invalid url',
      ],
      fieldRequired: [
        v => !!v || 'Field is required.',
      ],
      bulk: {
        label: 'Select All',
        value: 0,
      },
      form: {
        businesses: [],
      },
      
      headers: [
        { text: 'Name', value: 'name', sortable: false, class: 'font-weight-bold'},
      ],
    };
  },
  computed: {
   
    businessIds() {
      return Helper.getFieldValueInArray(this.allBusinesses, 'id');
    },
    ...mapGetters({
      allBusinesses: 'business/list',
      addAppToBusiness: 'superadminapps/addAppToBusiness',
      addAppToBusinessObj: 'superadminapps/addAppToBusinessObj',
    }),

  },
  watch: {

    addAppToBusinessObj(val) {
       if(!_.isEmpty(val)){
        this.fetchExistingAppToBusiness(val.id);
      }
    },

   'form.businesses'(val) {
      if(this.form.businesses.length > 0){
        if(this.form.businesses.length >= this.businessIds.length) {
          this.bulk =  {
            label: 'Deselect All',
            value: 1,
          };
        } else {
          this.bulk =  {
            label: 'Select All',
            value: 0,
          };
        }
      } else {
        this.bulk =  {
          label: 'Select All',
          value: 0,
        };
      }
    },
  },
  
  created() {
   // We need list of all business for this so lets add 
    this.fetchAllBusiness();
    this.closeModal();
  
  },
  methods: {
      /**
     * Get business list
     */
        /**
     * Bulk select toggle
     */
    bulkSelectToggle() {
      if(this.bulk.value) {
        this.form.businesses = this.businessIds;
      } else {
        this.form.businesses = [];
      }
    },

    /**
     * Fetch existing 
     */
    fetchExistingAppToBusiness(appId) {
       this.spinner(true);
      const url = `${Env.url}/api/v1/apps/${appId}/businesses`;
      AuthApi.getApi(url)
        .then((res) => {
          this.spinner(false);
          res.data.payload.map(item => {
            this.form.businesses.push(item.id);
          })
        })
        .catch((err) => {
          this.spinner(false);
          console.log('Unable to fetch existing app to businesses')
        });
    },

    /**
     * Add app to business
     */
    addAppToBusinessSubmit() {
      this.spinner(true);
      const url = `${Env.url}/api/v1/apps/${ this.addAppToBusinessObj.id }/businesses`;
      AuthApi.postApi(url, this.form)
        .then((res) => {
          this.spinner(false);
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
          this.closeModal();
        })
        .catch(() => {
          this.snackbar({
            text: res.response.data.msg,
            timeout: 4000,
            open: true,
          });
          console.log('Unable to add app to businesses')
        });
    },

    fetchAllBusiness() {
      const url = `${Env.url}/api/v1/businesses`;
      AuthApi.getApi(url)
        .then((res) => {
          this.setBusinessList(res.data.payload);
        })
        .catch(() => {
          console.log('Unable to fetch business.');
        });
    },

    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      this.setAddAppToBusiness(false);
      this.setAddAppToBusinessObj({});
      this.form.businesses = [];
    },

    ...mapActions({
      setAddAppToBusiness: 'superadminapps/setAddAppToBusiness',
      setAddAppToBusinessObj: 'superadminapps/setAddAppToBusinessObj',
      setBusinessList: 'business/setList',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>

